export function trimText(text: string, maxLength = 121): string {
  return text.length > maxLength
    ? text.slice(0, maxLength - 3).trim() + '...'
    : text;
}
